<template>
  <p class="note note--promo" >Er hebben zich nog geen leerlingen aangemeld voor deze klas. Leerlingen kunnen zich registreren via <strong><a :href="'//'+registerLink">{{ registerLink }}</a></strong> met code <strong>{{ group.code }}</strong></p>
</template>


<script>
export default {
    props: {
        group: {},
    },

    computed: {
        registerLink: function() {
            return document.location.host + '/registreren'
        },
    }

}
</script>


<style lang="scss">
    //@import 'global';
</style>



// WEBPACK FOOTER //
// EmptyGroupMessage.vue?9e2f5752